import styled, { keyframes } from 'styled-components';

const ANIMATION_SPEED = 1;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: left;
  width: 80%;
  max-width: 80%;
  max-height: 90%;

  @media only screen and (max-width: 600px) {
    width: 90%;
    max-width: 90%;
  }
`;

const fadeIn = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 100%;
    }
`;

export const HelloText = styled.div`
  font-size: 4rem;
  color: ${({ theme }) => theme.colours.fg};
  animation: ${`${ANIMATION_SPEED}s`} ${fadeIn};
`;

export const NameText = styled.div`
  font-size: 2rem;
  color: ${({ theme }) => theme.colours.fg};
  animation: ${`${ANIMATION_SPEED}s`} ${fadeIn} ${`${ANIMATION_SPEED * 1.5}s`}
    both;
  padding: 1.5rem 0;
`;

export const BodyText = styled.div`
  animation: ${`${ANIMATION_SPEED}s`} linear ${`${ANIMATION_SPEED * 3}s`}
    ${fadeIn} both;

  img {
    height: 300px;
    width: auto;
    max-width: 80%;
    max-height: 30%;
  }

  @media only screen and (max-width: 600px) {
    img {
      height: auto;
      max-height: 200px;
    }
  }
`;
